import { InjectionToken } from '@angular/core';

/**
 * App-level values the shared UI needs. Provided by each application from its own
 * environment file, so shared components never import an app environment directly.
 */
export interface IGrayUiConfig {
  defaultProfilePhoto: string;
  flowPlayerToken?: string;
  videoProxyToken?: string;
}

export const GRAY_UI_CONFIG = new InjectionToken<IGrayUiConfig>('GRAY_UI_CONFIG');
